import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navbar } from 'reactstrap';

class AnnouncementBar extends Component {

  render() {
    return (
      <div className="box-shadow">
        <Navbar className={`nav-logo justify-content-center ps-3 announcement_bg`} light expand="md">
          <a className='announcement_text_color'>{this.props.locationSettings.announcement}</a>
        </Navbar>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { locationSettings } = state;
  return { locationSettings };
}
export default connect(mapStateToProps)(AnnouncementBar);
